export interface ReceiptSmsFundOverride {
  fundId: string;
  body: string;
}

export interface ReceiptSmsSettings {
  enabled: boolean;
  body: string;
  fundOverrides: ReceiptSmsFundOverride[];
}

export interface GivingSettings {
  defaultTitheFundId: string | null;
  defaultOfferingFundId: string | null;
  defaultContributionFundId: string | null;
  defaultPledgeFundId: string | null;
  defaultProjectFundId: string | null;
  defaultEventRegistrationFundId: string | null;
  receiptSms: ReceiptSmsSettings;
}

export type DefaultFundPurpose =
  | 'tithe'
  | 'offering'
  | 'contribution'
  | 'pledge'
  | 'project'
  | 'eventRegistration';

interface FundOption {
  id: string;
  defaultCurrency: string;
  isActive: boolean;
}

export function resolveDefaultFund(
  settings: GivingSettings | undefined,
  purpose: DefaultFundPurpose,
  funds: FundOption[] | undefined,
): { fundId: string | null; currency: string | null } {
  if (!settings || !funds?.length) {
    return { fundId: null, currency: null };
  }

  const configuredId =
    purpose === 'tithe'
      ? settings.defaultTitheFundId
      : purpose === 'offering'
        ? settings.defaultOfferingFundId
        : purpose === 'contribution'
          ? settings.defaultContributionFundId
          : purpose === 'pledge'
            ? settings.defaultPledgeFundId
            : purpose === 'project'
              ? settings.defaultProjectFundId
              : settings.defaultEventRegistrationFundId;

  if (!configuredId) {
    return { fundId: null, currency: null };
  }

  const fund = funds.find((row) => row.id === configuredId && row.isActive);
  if (!fund) {
    return { fundId: null, currency: null };
  }

  return { fundId: fund.id, currency: fund.defaultCurrency };
}

export function defaultFundPurposeForKind(kind: string): DefaultFundPurpose {
  if (kind === 'tithe') return 'tithe';
  if (kind === 'offering') return 'offering';
  return 'contribution';
}
